<template>
	<div class="school-container">
		<a-tabs type="card" v-model="activeKey" @change="tabChange">
			<a-tab-pane key="klass" tab="班级列表">
				<div class="school-content">
					<div class="school-search clearfix" v-if="isManager">
						<a-button class="fr" icon="plus" @click="showKlassModal">添加班级</a-button>
					</div>
					<a-table :loading="loading.klass" :columns="klassColumns" :data-source="tableSource.klass"
						:rowKey="(record) => record.id" :pagination="false" :bordered="false">
						<template slot="operation" slot-scope="text, record">
							<a class="school-table_btn" href="javascript:;" @click="klassHandle(record)">
								<svg-icon iconClass="eye"></svg-icon>
								<span class="school-table_btn_text">查看班级信息</span>
							</a>
						</template>
						<template slot="logo_url" slot-scope="text">
							<span v-if="text" class="school-klass_logo" :style="getBgStyle(text)">
							</span>
							<span v-else class="school-klass_logo" :style="getBgStyle(klassLogo)">
							</span>
						</template>
					</a-table>
				</div>
			</a-tab-pane>
			<a-tab-pane key="student" tab="学生列表">
				<div class="school-content">
					<div class="school-search">
						<a-select class="width-160" v-model="params.student.klass_id" placeholder="请选择所属班级"
							:allowClear="isManager" @change="getStudentList">
							<a-select-option v-for="item in tableSource.klass" :value="item.id" :key="item.id">
								{{ item.name }}
							</a-select-option>
						</a-select>
						<a-input icon="search" class="width-160 m-left-10" v-model="params.student.name"
							placeholder="请输入学生姓名" @change="getStudentList">
							<a-icon slot="prefix" style="color: #999999;" type="search" />
						</a-input>
						<a-button class="fr" icon="plus" @click="studentHandle('student')">添加学生</a-button>
					</div>

					<a-table :loading="loading.student" :columns="studentColumns" :data-source="tableSource.student"
						:rowKey="(record) => record.id" :pagination="false" :bordered="false">
						<template slot="authStatus" slot-scope="text, record">
							<span>
								<a-icon v-if="computedAuthStatus(record) === 'Authed'" class="m-right-5"
									type="check-circle" theme="filled" />
								<a-icon v-else-if="computedAuthStatus(record) === 'Authing'" class="m-right-5"
									type="minus-circle" theme="filled" />
								<svg-icon v-else-if="computedAuthStatus(record) === 'UnAuthed'" class="m-right-5"
									iconClass="decline" style="font-size: 14px;" />
								{{ computedAuthStatusText(record) }}
							</span>
						</template>
						<template slot="operation" slot-scope="text, record">
							<div class="school-table_btn">
								<a class="school-table_btn" href="javascript:;"
									@click="studentHandle('student', record.id)">
									<svg-icon iconClass="eye"></svg-icon>
									<span class="school-table_btn_text">查看详情</span>
								</a>
								<!-- <a class="school-table_btn" href="javascript:;"
									@click="studentHandle('kinsfolk', record.id)">
									<svg-icon iconClass="plus"></svg-icon>
									<span class="school-table_btn_text">添加家长</span>
								</a> -->
							</div>
						</template>
					</a-table>
				</div>
			</a-tab-pane>
			<a-tab-pane key="kinsfolk" tab="家长列表">
				<div class="school-content">
					<div class="school-search">
						<a-select class="width-160" v-model="params.kinsfolk.klass_id" placeholder="请选择所属班级"
							:allowClear="isManager" @change="getStudentList">
							<a-select-option v-for="item in tableSource.klass" :value="item.id" :key="item.id">
								{{ item.name }}
							</a-select-option>
						</a-select>
						<a-input icon="search" class="width-160 m-left-10" v-model="params.kinsfolk.name"
							placeholder="请输入家长姓名" @change="getStudentList">
							<a-icon slot="prefix" style="color: #999999;" type="search" />
						</a-input>
					</div>

					<a-table :loading="loading.kinsfolk" :columns="kinsfolkColumns" :data-source="tableSource.kinsfolk"
						:rowKey="(record) => record.id" :pagination="false" :bordered="false">
						<template slot="operation" slot-scope="text, record">

							<div class="school-table_btn">
								<a class="school-table_btn m-right-20"
									:class='{ "school-table_btn_disabled ": !["MATCHED", "ACCEPTED"].includes(record.status) }'
									href="javascript:;" @click="authHandle(record)">
									<svg-icon iconClass="auth"></svg-icon>
									<span class="school-table_btn_text">认证</span>
								</a>
								<a class="school-table_btn" href="javascript:;"
									@click="studentHandle('kinsfolk', record.studentId, record.id)">
									<svg-icon iconClass="eye"></svg-icon>
									<span class="school-table_btn_text">查看</span>
								</a>
							</div>
						</template>
						<template slot="status" slot-scope="status">
							<span>
								<a-icon v-if="status === 'ACCEPTED'" class="m-right-5" type="check-circle"
									theme="filled" />
								<a-icon v-else-if="status === 'NO_MATCH' || status === 'MATCHED'" class="m-right-5"
									type="minus-circle" theme="filled" />
								<svg-icon v-if="status === 'DECLINED'" class="m-right-5" iconClass="decline"
									style="font-size: 14px;" />
								{{ KINSFOLK_STATUS[status] }}
							</span>
						</template>
					</a-table>
				</div>
			</a-tab-pane>
			<a-tab-pane key="teacher" tab="教师列表">
				<div class="school-content">
					<div class="school-search">
						<a-select class="width-160" v-model="params.teacher.klass_id" placeholder="请选择所属班级"
							:allowClear="isManager" @change="getTeacherList">
							<a-select-option v-for="item in 		tableSource.klass" :value="item.id" :key="item.id">
								{{ item.name }}
							</a-select-option>
						</a-select>
						<a-input icon="search" class="width-160 m-left-10" v-model="params.teacher.name"
							placeholder="请输入老师姓名" @change="getTeacherList">
							<a-icon slot="prefix" style="color: #999999;" type="search" />
						</a-input>
						<a-button class="fr" icon="plus" v-if="isManager" @click="teacherHandle()">添加老师</a-button>
					</div>

					<a-table :loading="loading.teacher" :columns="teacherColumns" :data-source="tableSource.teacher"
						:rowKey="(record) => record.id" :pagination="false" :bordered="false">
						<template slot="operation" slot-scope="text, record">
							<a class="school-table_btn" href="javascript:;" @click="teacherHandle(record)">
								<svg-icon iconClass="eye"></svg-icon>
								<span class="school-table_btn_text">查看详情</span>
							</a>
						</template>
					</a-table>
				</div>
			</a-tab-pane>
			<a-tab-pane key="admin" tab="管理员列表" v-if="isManager">
				<div class="school-content">
					<div class="school-search clearfix">
						<a-button class="fr" icon="plus" @click="showCreateModal">添加管理员</a-button>
					</div>

					<a-table :loading="loading.admin" :columns="adminColumns" :data-source="tableSource.admin"
						:rowKey="(record) => record.id" :pagination="false" :bordered="false">
						<template slot="operation" slot-scope="text, record">
							<a v-if="record.user_id !== userInfo.id" class="school-table_btn del-color" href="javascript:;" @click="delAdminHandle(record)">
								<svg-icon iconClass="delete"></svg-icon>
								<span class="school-table_btn_text">删除</span>
							</a>
						</template>
					</a-table>
				</div>
			</a-tab-pane>
		</a-tabs>

		<a-modal title="添加班级" v-model="klassModalInfo.visible" :confirm-loading="klassModalInfo.loading"
			@ok="createKlassHandle">
			<div class="school-modal_item">
				<span class="school-modal_label">班级名称：</span>
				<a-input class="school-modal_input" v-model="klassModalInfo.name" placeholder="请输入班级名称" />
			</div>
		</a-modal>

		<a-modal title="添加管理员" v-model="adminModalInfo.visible" :confirm-loading="adminModalInfo.loading"
			@ok="createAdminHandle">
			<div class="school-modal_item">
				<span class="school-modal_label">老师名称：</span>
				<a-select class="school-modal_input" v-model="adminModalInfo.id" placeholder="请选择教师" >
					<a-select-option v-for="item in filterTeacherList" :value="item.id" :key="item.id">
						{{ item.name }}
					</a-select-option>
				</a-select>
			</div>
		</a-modal>


		<div class="auth-modal" v-if="authModal.visible">
			<div class="auth-modal_mask"></div>
			<div class="auth-modal_content">
				<div class="auth-modal_name">
					{{ authModal.title }}
					<span :class="`m-left-5 AUTH_STATUS_${authModal.status}`">
						(<a-icon v-if="authModal.status === 'ACCEPTED'" style="font-size:12px" type="check-circle"
							theme="filled" />
						<a-icon v-else-if="authModal.status === 'NO_MATCH' || status === 'MATCHED'"
							style="font-size:12px" type="minus-circle" theme="filled" />
						<svg-icon v-if="authModal.status === 'DECLINED'" iconClass="decline" style="font-size: 12px;" />
						{{ KINSFOLK_STATUS[authModal.status] }})
					</span>

				</div>
				<a-icon class="auth-modal_close" type="close" @click="authModal.visible = false" />
				<div class="auth-modal_title">
					<span>老师录入信息</span>
					<span>家长提交信息</span>
				</div>
				<a-row>
					<a-col :span="12">
						<div class="auth-modal_left">
							<div class="p-top-10">
								<span class="auth-modal_label">家长姓名</span>
								<span class="auth-modal_value">{{ authModal.name || "--" }}</span>
							</div>
							<div>
								<span class="auth-modal_label">家长手机号</span>
								<span>{{ authModal.mobile }}</span>
							</div>
							<div>
								<span class="auth-modal_label">亲属关系</span>
								<span>{{ authModal.relationship || "--" }}</span>
							</div>
						</div>
					</a-col>
					<a-col :span="12">
						<div class="p-top-10">
							<span class="auth-modal_label">家长姓名</span>
							<span>{{ authModal.matched_kinsfolk && authModal.matched_kinsfolk.name || "--" }}</span>
						</div>
						<div>
							<span class="auth-modal_label">家长手机号</span>
							<span>{{ authModal.matched_kinsfolk && authModal.matched_kinsfolk.mobile || "--" }}</span>
						</div>
						<div>
							<span class="auth-modal_label">亲属关系</span>
							<span>
								{{ authModal.matched_kinsfolk && authModal.matched_kinsfolk.relationship || "--" }}
							</span>
						</div>
					</a-col>
				</a-row>

				<div class="auth-modal_btn">
					<a-button class="width-100" :disabled="!authModal.canDecline" type="danger"
						@click="declineHandle">驳回</a-button>
					<a-button class="width-100" :disabled="!authModal.canPass" type="primary"
						@click="acceptHandle">通过</a-button>
				</div>
			</div>
		</div>
	</div>
</template>
  
<script>
import klassLogo from "@/assets/images/klass_logo.png"
import columnsSource from "./constant"
import KlassService from "@/api/klassService"
import StudentService from "@/api/studentService"
import TeacherInfoService from "@/api/teacherService"
import { mapGetters } from "vuex"
import dict from "@/config"

export default {
  name: "school",
  components: {},
  data() {
    return {
      klassLogo,
      activeKey: "klass",
      params: {
        klass: {},
        student: {},
        kinsfolk: {},
        teacher: {}
      },
      loading: {
        klass: false,
        kinsfolk: false,
        student: false,
        teacher: false,
        admin: false
      },
      tableSource: {
        klass: [],
        student: [],
        kinsfolk: [],
        teacher: [],
        admin: []
      },
      klassColumns: columnsSource.getKlassColumns(),
      studentColumns: columnsSource.getStudentColumns(),
      kinsfolkColumns: columnsSource.getKinsfolkColumns(),
      teacherColumns: columnsSource.getTeacherColumns(),
      adminColumns: columnsSource.getAdminColumns(),
      KINSFOLK_STATUS: dict.KINSFOLK_STATUS,
      klassModalInfo: {
        visible: false,
        loading: false,
        name: undefined
      },
      authModal: {
        visible: false,
        loading: false,
        title: "家长认证-王小黑"
      },
      adminModalInfo: {
        visible: false,
        loading: false,
        id: undefined
      },

      teacherSource: []
    }
  },

  computed: {
    ...mapGetters(["isManager", "teacherInfo", "curKlassId", "klassList", "roleList", "userInfo"]),
    computedAuthStatusText() {
      return function(record) {
        const kinsflokList = record.kinsfolk_info_from_teacher_list || []
        if (!kinsflokList.length) {
          return "暂无认证"
        }
        if (kinsflokList.find(item => item.status === "MATCHED")) {
          return "待认证"
        }
        if (kinsflokList.find(item => item.status === "NO_MATCH")) {
          return "待匹配"
        }
        if (kinsflokList.find(item => item.status === "DECLINED")) {
          return "已驳回"
        }
        if (kinsflokList.find(item => item.status === "ACCEPTED")) {
          return "已认证"
        }
        if (kinsflokList.find(item => item.status === "INVALID")) {
          return "已失效"
        }
        return "未知状态"
      }
    },
    computedAuthStatus() {
      return function(record) {
        const kinsflokList = record.kinsfolk_info_from_teacher_list || []
        if (!kinsflokList.length) {
          return ""
        }
        if (kinsflokList.find(item => item.status === "MATCHED") || kinsflokList.find(item => item.status === "NO_MATCH")) {
          return "Authing"
        }

        if (kinsflokList.find(item => item.status === "ACCEPTED")) {
          return "Authed"
        }

        if (kinsflokList.find(item => item.status === "DECLINED")) {
          return "UnAuthed"
        }

        return ""
      }
    },
    getBgStyle() {
      return function(thumbnail_url) {
        return {
          background: `url(${thumbnail_url}) no-repeat center center`,
          backgroundSize: "cover"
        }
      }
    },

    filterTeacherList() {
      return this.teacherSource.filter(item => !item.teachers.length || !item.teachers.find(teacher => teacher.role.permission === "MANAGER"))
    }
  },

  created() {
    this.initHandle()
  },

  methods: {
    tabChange() {
      this.$router.replace({
        name: "school",
        query: { type: this.activeKey }
      })

      switch (this.activeKey) {
        case "student":
          if (!this.tableSource.student.length) {
            this.getStudentList()
          }
          break
        case "kinsfolk":
          if (!this.tableSource.kinsfolk.length) {
            this.getStudentList()
          }
          break
      }
    },

    initHandle() {
      const { type, ...params } = this.$route.query
      this.activeKey = type || "klass"
      if (!this.isManager) {
        this.params.student = { klass_id: this.curKlassId }
        this.params.kinsfolk = { klass_id: this.curKlassId }
        this.params.teacher = { klass_id: this.curKlassId }
      }
      delete params.random
      this.params[this.activeKey] = {
        ...this.params[this.activeKey],
        ...params
      }
      this.getKlassList(true)

      if (this.isManager) {
        this.$store.dispatch("getRoleListService")
      }
    },

    getKlassList(isForce = false) {
      this.$store.dispatch("getKlassListService", { isForce }).then(res => {
        this.tableSource.klass = res || []
        this.getStudentList()
        this.getTeacherList()
      })
    },

    getTeacherList() {
      this.$router.replace({
        name: "school",
        query: { ...this.$route.query, ...this.params.teacher }
      })
      this.teacherColumns = columnsSource.getTeacherColumns(this.params.teacher.klass_id)
      TeacherInfoService.getTeacherInfoListService({
        klass_id: this.params.teacher.klass_id,
        school_id: this.teacherInfo.school_id,
        isManager: this.isManager
      }).then((res = []) => {
        let teacherList = res
        this.teacherSource = res
        if (this.isManager && this.params.teacher.klass_id) {
          teacherList = teacherList.filter(item => {
            return item.teachers && item.teachers.length && item.teachers.find(teacher => teacher.klass && teacher.klass.id === this.params.teacher.klass_id)
          })
        }

        if (this.params.teacher.name) {
          teacherList = teacherList.filter(item => item.name && item.name.indexOf(this.params.teacher.name) > -1)
        }

        this.tableSource.teacher = teacherList

        this.tableSource.admin = (res || []).filter(item => item.teachers.length && item.teachers.find(teacher => teacher.role.permission === "MANAGER"))
      })
    },

    getStudentList() {
      let params = { school_id: this.teacherInfo.school_id }
      let name = undefined
      if (this.activeKey === "kinsfolk") {
        params.klass_id = this.params.kinsfolk.klass_id
        name = this.params.kinsfolk.name
        this.$router.replace({
          name: "school",
          query: { ...this.$route.query, ...this.params.kinsfolk }
        })
      } else {
        params.klass_id = this.params.student.klass_id
        name = this.params.student.name
        this.$router.replace({
          name: "school",
          query: { ...this.$route.query, ...this.params.student }
        })
      }
      StudentService.getStudentListService(params).then(res => {
        let studentList = (res || []).filter(item => {
          const _klassInfo = this.klassList.find(klass => klass.id === item.klass_id)

          return _klassInfo !== undefined
        })
        let kinsfolkList = []
        studentList.forEach(item => {
          item.kinsfolk_info_from_teacher_list.forEach(kinsfolk => {
            kinsfolkList.push({
              ...kinsfolk,
              kidName: item.kid_name,
              klassId: item.klass_id,
              studentId: item.id
            })
          })
        })

        // 班级筛选
        if (params.klass_id) {
          studentList = studentList.filter(item => item.klass_id === params.klass_id)
          kinsfolkList = kinsfolkList.filter(item => item.klassId === params.klass_id)
        }

        // 名称筛选
        if (name) {
          studentList = studentList.filter(item => item.kid_name && item.kid_name.indexOf(name) > -1)
          kinsfolkList = kinsfolkList.filter(item => item.name && item.name.indexOf(name) > -1)
        }

        if (this.activeKey === "student") {
          this.tableSource.student = studentList
        } else if (this.activeKey === "kinsfolk") {
          this.tableSource.kinsfolk = kinsfolkList
        } else {
          this.tableSource.kinsfolk = kinsfolkList
          this.tableSource.student = studentList
        }
      })
    },

    studentHandle(origin, student_id, kinsfolk_id) {
      const query = { klass_id: this.params.student.klass_id, origin }
      if (origin === "kinsfolk") {
        query.klass_id = this.params.kinsfolk.klass_id
      }

      if (student_id) {
        query.student_id = student_id
      }
      if (kinsfolk_id) {
        query.kinsfolk_id = kinsfolk_id
      }
      this.$router.push({ name: "studentDetail", query })
    },

    teacherHandle(record = {}) {
      this.$router.push({
        name: "teacherDetail",
        query: { id: record.id }
      })
    },

    klassHandle(record = {}) {
      this.$router.push({
        name: "klassDetail",
        query: { id: record.id }
      })
    },

    showKlassModal() {
      Object.assign(this.klassModalInfo, {
        visible: true,
        loading: false,
        name: undefined
      })
    },

    createKlassHandle() {
      if (!this.klassModalInfo.name || !this.klassModalInfo.name.trim().length) {
        this.$message.warning("班级名称不可为空")
        return
      }

      if (this.klassList.find(item => item.name === this.klassModalInfo.name.trim())) {
        this.$message.warning("当前班级名称已存在")
        return
      }
      this.klassModalInfo.loading = true
      KlassService.createKlassService({
        name: this.klassModalInfo.name.trim(),
        school_id: this.teacherInfo.school_id
      })
        .then(() => {
          this.$message.success("添加成功!")
          this.getKlassList(true)
          this.klassModalInfo.visible = false
        })
        .catch(() => {
          this.klassModalInfo.loading = false
          this.$message.success("操作失败，请检查后重试")
        })
    },

    authHandle(record) {
      if (!["MATCHED", "ACCEPTED"].includes(record.status)) return
      this.authModal = {
        visible: true,
        loading: false,
        title: `家长认证-${record.kidName}`,
        canDecline: ["MATCHED", "ACCEPTED"].includes(record.status),
        canPass: ["MATCHED"].includes(record.status),
        ...record
      }
    },

    acceptHandle() {
      this.$confirm({
        title: "提示信息",
        content: `是否通过当前家长 ${this.authModal.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise((resolve, reject) => {
            StudentService.acceptKinsfolkService({
              kinsfolk_info_from_teacher_id: this.authModal.id
            })
              .then(() => {
                this.$message.success("操作成功")
                this.authModal.visible = false
                this.getStudentList()
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    declineHandle() {
      this.$confirm({
        title: "提示信息",
        content: `是否驳回当前家长 ${this.authModal.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise((resolve, reject) => {
            StudentService.declineKinsfolkService({
              kinsfolk_info_from_teacher_id: this.authModal.id
            })
              .then(() => {
                this.$message.success("操作成功")
                this.authModal.visible = false
                this.getStudentList("kinsfolk")
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    delAdminHandle(record) {
      const adminRole = record.teachers.find(item => item.role.permission === "MANAGER")
      this.$confirm({
        title: "提示信息",
        content: `是否移除当前管理员 ${record.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise((resolve, reject) => {
            TeacherInfoService.deactivateKlassTeacherService({
              teacherId: adminRole.id
            })
              .then(() => {
                this.$message.success("操作成功")
                this.getTeacherList()
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    showCreateModal() {
      this.adminModalInfo = {
        loading: false,
        visible: true,
        id: undefined
      }
    },

    createAdminHandle() {
      if (!this.adminModalInfo.id) {
        this.$message.warning("请先选择老师")
        return
      }

      this.adminModalInfo.loading = true
      const teacher = this.teacherSource.find(item => item.id === this.adminModalInfo.id)
      const { name, school_id, id, user_id } = teacher

      TeacherInfoService.createKlassTeacherService({
        name,
        user_id,
        school_id,
        role_id: this.roleList.find(item => item.permission === "MANAGER").id,
        teacher_info_id: id,
        is_active: true
      })
        .then(() => {
          this.adminModalInfo.visible = false
          this.adminModalInfo.loading = false
          this.$message.success("操作成功")
          this.getTeacherList()
        })
        .catch(() => {
          this.adminModalInfo.loading = false
          this.$message.error("操作失败，请重新操作")
        })
    }
  }
}
</script>
  
<style lang="less" scoped>
.school {
  &-container {
    background: #ffffff;
    min-height: calc(100% - 65px);
    margin-top: 15px;

    /deep/.ant-tabs-nav-scroll {
      background: #f0f2f5;
    }

    /deep/.ant-tabs-tab {
      border: none !important;
      margin: 0 !important;
    }

    /deep/.ant-tabs-bar {
      margin-bottom: 0;
    }
  }

  &-title {
    height: 50px;
    line-height: 24px;
    background: #f0f2f5;
  }

  &-content {
    padding: 28px 28px 2px 30px;
  }

  &-search {
    margin-bottom: 20px;
  }

  &-klass {
    &_logo {
      display: block;
      width: 46px;
      height: 46px;
      margin: 0 auto;
      border-radius: 50%;
    }
  }

  &-table {
    &_btn {
      display: flex;
      flex-flow: nowrap row;
      align-items: center;
      justify-content: center;
      line-height: 1;

      &_text {
        margin-left: 5px;
        line-height: 1;
      }

      &_disabled {
        cursor: not-allowed;
        color: rgba(0, 0, 0, 0.25);
        border-color: #d9d9d9;
      }
    }
  }

  &-modal {
    &_item {
      display: flex;
      flex-flow: nowrap row;
      justify-content: space-between;
      align-items: center;
    }

    &_label {
      width: 100px;
    }

    &_input {
      width: 200px;
      flex-grow: 1;
    }
  }
}

.auth {
  &-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;

    &_mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.45);
    }

    &_content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 600px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
      padding: 20px 0;
    }

    &_name {
      padding: 0 0 15px;
      text-align: center;
      font-size: 16px;
      color: #1890ff;
    }

    &_close {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 16px;
      cursor: pointer;
    }

    &_title {
      display: flex;
      flex-flow: nowrap row;
      padding: 8px 0;
      margin: 0 30px;
      border-bottom: 1px solid #e8e8e8;
      color: #333333;

      span {
        flex-grow: 1;
        text-align: center;
      }
    }

    &_left {
      border-right: 1px solid #e8e8e8;
    }

    &_label {
      display: inline-block;
      width: 85px;
      margin: 0 10px 0 50px;
      padding: 6px 0;
    }

    &_value {
      display: inline-block;
      padding: 6px 0;
    }

    &_btn {
      display: flex;
      flex-flow: nowrap row;
      justify-content: space-around;
      padding: 15px 0 0;
    }
  }
}
</style>
